export function trendBadge(trendClass?: string): string {
  switch (trendClass) {
    case 'up':
      return '↑ рост';
    case 'down':
      return '↓ падение';
    case 'stable':
      return '→ стабильно';
    case 'insufficient_data':
      return 'недостаточно данных';
    default:
      return '—';
  }
}

export function severityLabel(severity: string): string {
  switch (severity) {
    case 'critical':
      return 'Критично';
    case 'warning':
      return 'Внимание';
    default:
      return 'Инфо';
  }
}

export function runStatusLabel(status: string): string {
  switch (status) {
    case 'completed':
      return 'Завершён';
    case 'completed_with_warnings':
      return 'С предупреждениями';
    case 'failed':
      return 'Ошибка';
    case 'running':
      return 'Выполняется';
    case 'created':
      return 'Создан';
    default:
      return status;
  }
}

export function formatAnalysisDate(value?: string): string {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function formatPeriodDate(value?: string): string {
  if (!value) return '—';
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  if (!match) return formatAnalysisDate(value);
  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return date.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function todayIsoDate(): string {
  return new Date().toISOString().slice(0, 10);
}

export function monthAgoIsoDate(): string {
  const date = new Date();
  date.setUTCDate(date.getUTCDate() - 30);
  return date.toISOString().slice(0, 10);
}

export function isSuccessfulRunStatus(status?: string): boolean {
  return status === 'completed' || status === 'completed_with_warnings';
}

export function formatRub(value: number, fractionDigits = 1): string {
  return value.toLocaleString('ru-RU', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
}

const EVIDENCE_LABELS: Record<string, string> = {
  'Finance unattributed': 'Начисления кабинета без SKU, ₽',
  'Promo unattributed': 'Промо без SKU, ₽',
};

export function formatEvidenceLabel(label: string): string {
  return EVIDENCE_LABELS[label] ?? label;
}

export function formatEvidenceValue(path: string, value: unknown): string {
  if (value == null) {
    return '—';
  }
  if (typeof value === 'boolean') {
    return value ? 'да' : 'нет';
  }
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return String(value);
  }

  const isRatio =
    path.endsWith('returnRate') ||
    path.endsWith('availabilityRate') ||
    path.endsWith('relativeChange') ||
    path.endsWith('confidence');
  const isPercent = path.includes('Percent');
  if (isRatio) {
    return `${(value * 100).toFixed(1)}%`;
  }
  if (isPercent) {
    return `${value.toFixed(1)}%`;
  }
  if (Number.isInteger(value) && !path.includes('economics') && !path.includes('unattributed') && !path.includes('promo')) {
    return String(value);
  }
  return formatRub(value);
}

export function cogsSourceLabel(source: string): string {
  if (source === 'purchase') {
    return 'подписанная закупка (Procurement)';
  }
  return source;
}

export const economicsExpenseKeyLabel: Record<string, string> = {
  commission: 'Комиссия',
  logistics: 'Логистика',
  last_mile: 'Последняя миля',
  acquiring: 'Эквайринг',
  posting_processing: 'Обработка отправления',
  storage: 'Хранение',
  return_expenses: 'Возвратная логистика',
  penalties: 'Штрафы',
  promotion: 'Продвижение',
  cogs: 'Себестоимость',
  tax: 'Налог',
};
